/** Pendant zu `Services/API/ApiDokumentService.cs`. */

import { API_BASE_URL } from '@/config/appConfig';
import type { ChinaAppSysConfig, Document } from '@/types/entities';

import {
  buildAppPath,
  createCrudApi,
  nullResult,
  requestOrFallback,
  type CrudApi,
} from '../apiBase';
import { apiClient } from '../httpClient';

const ENDPOINT = 'dokument';

/** Der Altclient typisiert diesen Service auf `ChinaAppSysConfig` — 1:1 übernommen. */
export const documentApi: CrudApi<ChinaAppSysConfig> & {
  upload(model: Document): Promise<Document>;
  buildDownloadUrl(token: string): string;
} = {
  ...createCrudApi<ChinaAppSysConfig>(ENDPOINT),

  upload: (model) =>
    requestOrFallback(
      () => apiClient.post<Document>(`${buildAppPath(ENDPOINT)}/upload`, model),
      nullResult<Document>(),
    ),

  buildDownloadUrl: (token) => `${API_BASE_URL}/${buildAppPath(ENDPOINT)}/download/${token}`,
};
